// extracted by mini-css-extract-plugin
export default {"uploadImgBtn":"file-upload_uploadImgBtn__1sG9B"};